<template>
  <b-modal
    ref="modal"

    title="Modify location"

    size="lg"
    centered
  >
    <template v-slot:default>
      <form class="form" @submit.prevent="submitForm">
        <div class="form-group">
          <label>Location <sup>Required</sup></label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i>
                  <font-awesome-icon :icon="['fas', 'map-marker-alt']" />
                </i>
              </span>
            </div>
            <location-autocomplete
              ref="locationAutocomplete"
              v-model="form.location"

              class="form-control"

              :disabled="isLoadingForm"
            />
          </div>
          <span class="form-text text-muted">The device's location will be used to present your devices on a map. Fill out any part of the address, company- or building name in the field above.</span>
        </div>
      </form>
    </template>

    <template v-slot:modal-footer>
      <button type="button" class="btn btn-secondary" :disabled="isLoadingForm" @click.prevent="close">Cancel</button>
      <button type="submit" class="btn btn-primary" :disabled="isLoadingForm" @click.prevent="submitForm">Modify</button>
    </template>
  </b-modal>
</template>

<script>
// import { required } from 'vuelidate/lib/validators';
import { validations } from '@vedicium/core-vue';
import { Mixins } from '@vedicium/metronic-vue';
import Equipment from '@/libs/classes/equipment';

import locationAutocomplete from '@/components/plugins/location-autocomplete/index.vue';

export default {
  mixins: [Mixins.Modal],
  name: 'modifyLocationModal',
  props: {
    equipment: {
      type: Equipment,
      default: null,
    },
  },
  components: {
    locationAutocomplete,
  },
  data () {
    return {
      options: null,
      isLoadingForm: false,

      form: {
        equipment: null,
        location: null,
      },
    };
  },
  validations: {
    form: {
      equipment: {

      },
    },
  },

  mounted () {
    // Listeners
    this.$eventhub.on('modals:equipment:modify-location:open', this.open);
    this.$eventhub.on('modals:equipment:modify-location:close', this.close);
  },
  beforeDestroy () {
    // Remove listeners
    this.$eventhub.off('modals:equipment:modify-location:open', this.open);
    this.$eventhub.off('modals:equipment:modify-location:close', this.close);
  },

  methods: {
    async validate () {
      await validations.validateArray([this.$v]);
    },
    async submitForm () {
      this.$set(this, 'isLoadingForm', true);

      try {
        await this.validate();

        if (this.options && typeof this.options.onSubmit === 'function') {
          await this.options.onSubmit(this.form.location);
        }
      } catch (e) {
        this.$errors.handle(e, { component: this });
        console.error(e);
        return;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }

      this.close();
    },

    open (options = {}) {
      if (!this.equipment) {
        throw new Error('Prop \'equipment\' undefined');
      }

      // Reset options
      this.$set(this, 'options', options);

      // Reset form
      this.$set(this.form, 'equipment', this.equipment.clone());
      this.$v.$reset();

      this.$refs.modal.show();
    },
    close () {
      this.$refs.modal.hide();
    },

    async onShown () {
      await this.$nextTick();

      this.$refs.locationAutocomplete.generateSessionToken();
      this.$refs.locationAutocomplete.focus();
    },
  },
};
</script>
